import { render, staticRenderFns } from "./AddNewOrderBox24.vue?vue&type=template&id=4b69c3d9&"
import script from "./AddNewOrderBox24.vue?vue&type=script&lang=js&"
export * from "./AddNewOrderBox24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports